import { Images } from "constants";
import React from "react";
import Slider from "react-slick";

const BrandSlider = ({ share, direction = false }) => {
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        // slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        variableWidth: true,
        rtl: direction
    };
    return (
        <React.Fragment>
            <div className="slider-container brand-slider-box relative">
                {!(share == 300 || share == 400) ?
                    <Slider {...settings} >
                        {[
                            { img: Images.HOTEXCH, label: "Hotexch", url: "https://hotexch.com" },
                            { img: Images.EXTRAEXCH, label: "ExtraExch", url: "https://extraexch.com" },
                            { img: Images.HOTEXCH, label: "Hotexch", url: "https://hotexch.com" },
                            { img: Images.EXTRAEXCH, label: "ExtraExch", url: "https://extraexch.com" },
                        ].map((item, index) => (
                            <div>
                                {!(share == 300 || share == 400) &&
                                    <div
                                        className='brand-slider-box-item focus:outline-none focus:ring-0 active:outline-none active:ring-0'>
                                        <div>
                                            {share &&
                                                <div className="website-link">
                                                    <div>
                                                        <div className="link-heading">Admin Link:</div>
                                                        <a
                                                            href={share ? `https://hotexch${share}.com/admin` : `https://hotexch.com`}
                                                            target="_blank" rel="noopener noreferrer" className="link-address">

                                                            {share ? `hotexch${share}.com/admin` : `hotexch.com/admin`}
                                                        </a>
                                                    </div>
                                                </div>}

                                            <img src={share == 10 ? Images.HOTEXCH_10
                                                : share == 15 ? Images.HOTEXCH_15
                                                    : share == 20 ? Images.HOTEXCH_20
                                                        : share == 25 ? Images.HOTEXCH_25
                                                            : share == 30 ? Images.HOTEXCH_30
                                                                : share == 40 ? Images.HOTEXCH_40
                                                                    : share == 50 ? Images.HOTEXCH_50
                                                                        : item.img} alt="" />
                                            <div>
                                                <div className="website-link">
                                                    <div>
                                                        <div className="link-heading">Player Link:</div>
                                                        <a
                                                            href={share ? `https://hotexch${share}.com`
                                                                : item.url ? item.url
                                                                    : `https://hotexch.com`}
                                                            target="_blank" rel="noopener noreferrer" className="link-address">

                                                            {share ? `hotexch${share}.com`
                                                                : item.label ? item.label
                                                                    : `hotexch.com`}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        ))}
                    </Slider>
                    :
                    <div className="brand-slider-heading text-center text-[10px]">
                        <p className="capitalize">Coming Soon...</p>
                    </div>}

            </div>
        </React.Fragment>
    );
}

export default BrandSlider;